<template>
  <div class="flag_manage" >
    <el-divider content-position="left">过程数据分析</el-divider>
    <div class="changeHeight m-tabs-content">
      <el-row type="flex">
        <el-col :span="2" class="tr m-label text_right">选择日期</el-col>
        <el-col :span="4">
          <div>
            <el-date-picker v-model="highSearch.search_date" type="date" size="mini" format="yyyy 年 MM 月 dd 日"
              value-format="yyyy-MM-dd" placeholder="选择日期">
            </el-date-picker>
          </div>
        </el-col>
        <el-col :span="2" :offset="2" class="tr m-label text_right">选择角色</el-col>
        <el-col :span="4">
          <el-select :filterable="true" collapse-tags v-model="highSearch.role" placeholder="请选择角色" size="mini" clearable>
            <el-option v-for="(item, index) in roles" :key="index" :label="item.role_name" :value="item.id">
            </el-option>
          </el-select>
        </el-col>
        <el-col :span="2" :offset="2" class="tr m-label text_right">选择人员</el-col>
        <el-col :span="4">
          <el-select :filterable="true" multiple collapse-tags v-model="highSearch.uid" placeholder="请选择人员" size="mini"
            clearable>
            <el-option v-for="(item, index) in conversionPeople" :key="index" :label="item.username" :value="item.id">
            </el-option>
          </el-select>
        </el-col>
        <el-col :span="3" class="tr">
          <el-button type="primary" size="mini" @click="handleSearch">查询</el-button>
          <el-button type="danger" size="mini" @click="handleCloseSearch">清除</el-button>
        </el-col>
      </el-row>
    </div>

    <el-tabs v-model="checkCircle" type="border-card" @tab-click="handleClick" style="margin-top: 0.2rem;">
      <el-tab-pane label="本日" name="1">
        <el-divider content-position="left">日期：{{ date }}</el-divider>
        <el-table :data="goalData" border size="medium" style="width: 100%" height="460" v-cloak>
          
          <template v-if="flag === 0">
            <el-table-column label="考核人员" width="80">
              <template slot-scope="scope">
                <span class="count-style">
                  {{ scope.row.executor }}
                </span>
              </template>
            </el-table-column>
            <el-table-column label="考核项目" width="120">
              <template slot-scope="scope">
                <span class="count-style">
                  {{ scope.row.title }}
                </span>
              </template>
            </el-table-column>
            <el-table-column label="目标值" width="60">
              <template slot-scope="scope">
                <el-tag type="success" class="fontStyle">
                  {{ scope.row.check_num }}次
                </el-tag>
              </template>
            </el-table-column>
            <el-table-column label="完成值" width="60">
              <template slot-scope="scope">
                <el-tag class="fontStyle" 
                  :type="scope.row.num > scope.row.check_num ? 'success' : 'danger'">{{ scope.row.num
                  }}次</el-tag>
              </template>
            </el-table-column>
            <el-table-column label="完成率" width="60">
              <template slot-scope="scope">
                <el-tag class="fontStyle" effect="plain">{{ getFormattedResult(scope.row.num, scope.row.check_num) }}%</el-tag>
              </template>
            </el-table-column>
          </template>
          <template v-else>
            <el-table-column label="考核人员" width="80">
            <template slot-scope="scope">
              <span class="count-style">
                {{ scope.row.username }}
              </span>
            </template>
          </el-table-column>
            <el-table-column label="考核项目" width="120">
            <template slot-scope="scope">
              <span class="count-style">
                {{ scope.row.check_title }}
              </span>
            </template>
            </el-table-column>
            <el-table-column label="目标值" width="60">
              <template slot-scope="scope">
                <el-tag type="success" class="fontStyle">
                  {{ scope.row.check_num }}次
                </el-tag>
              </template>
            </el-table-column>
            <el-table-column label="完成值" width="60">
              <template slot-scope="scope">
                <el-tag class="fontStyle" 
                  :type="scope.row.finished_num > scope.row.check_num ? 'success' : 'danger'">{{ scope.row.finished_num
                  }}次</el-tag>
              </template>
            </el-table-column>
            <el-table-column label="是否合格" width="60">
              <template slot-scope="scope">
                <el-tag class="fontStyle" v-if="scope.row.finished_num > scope.row.check_num" type="success">合格</el-tag>
                <el-tag class="fontStyle" v-else type="danger">不合格</el-tag>
              </template>
            </el-table-column>
            <el-table-column label="完成率" width="60">
              <template slot-scope="scope">
                <el-tag class="fontStyle" effect="plain">{{ getFormattedResult(scope.row.finished_num, scope.row.check_num) }}%</el-tag>
              </template>
            </el-table-column>
          </template>

        </el-table>
      </el-tab-pane>

      <el-tab-pane label="本周" name="2">
        <el-divider content-position="left">日期：{{ date }}</el-divider>
        <el-table :data="goalData" border size="medium" style="width: 100%" v-cloak>
          <el-table-column label="考核人员" width="60">
            <template slot-scope="scope">
              <span class="count-style">
                {{ scope.row.executor }}
              </span>
            </template>
          </el-table-column>
          <el-table-column label="考核项目" width="120">
            <template slot-scope="scope">
              <span class="count-style">
                {{ scope.row.title }}
              </span>
            </template>
          </el-table-column>
          <el-table-column label="目标值" width="60">
            <template slot-scope="scope">
              <el-tag type="success" class="fontStyle">
                {{ scope.row.check_num }}次
              </el-tag>
            </template>
          </el-table-column>
          <el-table-column label="完成值" width="60">
            <template slot-scope="scope">
              <el-tag class="fontStyle" 
                :type="scope.row.num > scope.row.check_num ? 'success' : 'danger'">{{ scope.row.num
                }}次</el-tag>
            </template>
          </el-table-column>
          <el-table-column label="完成率" width="60">
            <template slot-scope="scope">
              <el-tag class="fontStyle" effect="plain">{{ getFormattedResult(scope.row.num, scope.row.check_num) }}%</el-tag>
            </template>
          </el-table-column>
        </el-table>
      </el-tab-pane>

      <el-tab-pane label="本月" name="3">
        <el-divider content-position="left">日期：{{ date }}</el-divider>
        <el-table :data="goalData" border size="medium" style="width: 100%" v-cloak>
          <el-table-column label="考核人员" width="60">
            <template slot-scope="scope">
              <span class="count-style">
                {{ scope.row.executor }}
              </span>
            </template>
          </el-table-column>
          <el-table-column label="考核项目" width="120">
            <template slot-scope="scope">
              <span class="count-style">
                {{ scope.row.title }}
              </span>
            </template>
          </el-table-column>
          <el-table-column label="目标值" width="60">
            <template slot-scope="scope">
              <el-tag type="success" class="fontStyle">
                {{ scope.row.check_num }}次
              </el-tag>
            </template>
          </el-table-column>
          <el-table-column label="完成值" width="60">
            <template slot-scope="scope">
              <el-tag class="fontStyle" 
                :type="scope.row.num > scope.row.check_num ? 'success' : 'danger'">{{ scope.row.num
                }}次</el-tag>
            </template>
          </el-table-column>
          <el-table-column label="完成率" width="60">
            <template slot-scope="scope">
              <el-tag class="fontStyle" effect="plain">{{ getFormattedResult(scope.row.num, scope.row.check_num) }}%</el-tag>
            </template>
          </el-table-column>
        </el-table>
      </el-tab-pane>

      <el-tab-pane label="本年" name="4">
        <el-divider content-position="left">日期：{{ date }}</el-divider>
        <el-table :data="goalData" border size="medium" style="width: 100%" v-cloak>
          <el-table-column label="考核人员" width="60">
            <template slot-scope="scope">
              <span class="count-style">
                {{ scope.row.executor }}
              </span>
            </template>
          </el-table-column>
          <el-table-column label="考核项目" width="120">
            <template slot-scope="scope">
              <span class="count-style">
                {{ scope.row.title }}
              </span>
            </template>
          </el-table-column>
          <el-table-column label="目标值" width="60">
            <template slot-scope="scope">
              <el-tag type="success" class="fontStyle">
                {{ scope.row.check_num }}次
              </el-tag>
            </template>
          </el-table-column>
          <el-table-column label="完成值" width="60">
            <template slot-scope="scope">
              <el-tag class="fontStyle" 
                :type="scope.row.num > scope.row.check_num ? 'success' : 'danger'">{{ scope.row.num
                }}次</el-tag>
            </template>
          </el-table-column>
          <el-table-column label="完成率" width="60">
            <template slot-scope="scope">
              <el-tag class="fontStyle" effect="plain">{{ getFormattedResult(scope.row.num, scope.row.check_num) }}%</el-tag>
            </template>
          </el-table-column>
        </el-table>
      </el-tab-pane>

    </el-tabs>
  </div>
</template>
  
<script>
import moment from 'moment';
export default {
  name: 'ProcessAnalysis',
  data() {
    return {
      highSearch: {
        search_date: '',
        role: null,
        uid: []
      },
      pageOption: {
        total: 0,
        currentPage: 1, // 当前页数
        currentPage2: 1, // 当前页数
        pageSize: 10 // 每页显示条数
      },

      conversionPeople: [],

      checkCircle: "1",
      date: '',

      goalData: [],
      currentAuthId: [],
      roles: [],
      flag: 0
    }
  },
  filters: {
    formatDate(value) {
      if (value) {
        // 使用 Moment.js 库进行日期格式化
        return moment(value).format('YYYY-MM-DD');
      } else {
        return '';
      }
    },
    toFixedTwo(value) {
      const num = parseFloat(value); // 将 value 转换为浮点型数值
      return num.toFixed(2);
    }
  },
  computed: {
    collapse() {
      return this.$store.state.collapse
    },
    searchStr: function () {
      let str = ''
      for (let key in this.highSearch) {
        str += '&' + key + '=' + this.highSearch[key]
      }
      return str
    },
  },
  watch: {},
  methods: {
    handelGetOrders() {
      this.$axios.post('/api/admin/process/check/get_user_process_check_data', {
        param: this.highSearch,
        checkCircle: this.checkCircle
      })
        .then((res) => {
          const { data } = res
          if (data.code === 0) {
            this.goalData = data.data.result
            this.flag = data.data.flag
            this.conversionPeople = data.data.conversionPeople
            this.roles = data.data.roles
            this.date = data.data.showDate
            this.currentAuthId = data.data.roleAuth
          }
        })
    },
    getFormattedResult(num, checkNum) {
      const result = ((num / checkNum) * 100).toFixed(2)
      return `${result}`
    },
    handleSearch() {
      this.handelGetOrders()
    },
    handleCloseSearch() {
      this.highSearch.search_date = ''
      this.highSearch.role = null
      this.highSearch.uid = []
      this.handelGetOrders()
    },
    handleSizeChange(val) {
      this.pageOption.pageSize = val
    },
    handleCurrentChange(val) {
      this.pageOption.currentPage = val
    },
    handleClick(tab) {
      console.log(tab)
      // 监听点击事件
      if (parseInt(tab.index) === 0) {
        // 日目标
        this.checkCircle = "1"
        this.handelGetOrders()
      } else if (parseInt(tab.index) === 1) {
        // 周目标
        this.checkCircle = "2"
        this.handelGetOrders()
      } else if (parseInt(tab.index) === 2) {
        // 月目标
        this.checkCircle = "3"
        this.handelGetOrders()
      } else if (parseInt(tab.index) === 3) {
        // 年目标
        this.checkCircle = "4"
        this.handelGetOrders()
      }
    },
  },
  mounted() {
    this.handelGetOrders()
  }
}
</script>
  
<style scoped lang="stylus">
    @import '~styles/varibles.styl'
    @import '~styles/vertical.styl'
    @import '~styles/icon.styl'
    .el-drawer__wrapper >>> .el-drawer
      overflow-y: auto
    .el-drawer__wrapper >>> .el-drawer__header span {
      color: #5789F4;
      font-size: 0.36rem;
      font-weight: 400;
    }
    .flag_manage
      marginLeft()
      .count_style
        display: inline-block
        overflow: hidden
        text-overflow: ellipsis
        white-space: nowrap
    .tr
      text-align: right
    .m-tabs-content
      overflow-y auto
      padding 0 .4rem
      box-sizing border-box
      .m-label
        line-height: .64rem
      .text_right
        text-align left
      .el-row
        margin-bottom: .4rem
    .flag_manage >>> .el-table__header th
      color: #333333
      background-color: #ECF4FF
    .mb-10
      margin-bottom: .2rem
      margin-top: 0.4rem
    .mt-10
      margin-top: .2rem
    .level
      display flex
      align-items center
      position relative
      padding-right .32rem
      img
        width .32rem
        height .30rem
      .el-icon-question
        margin-left: .1rem
        color: #409EFF
        position absolute
        top 0
        right 0
        cursor pointer
    .el-select, .el-cascader
      width: 100%
    .count
      padding-left: .2rem
      line-height: .56rem
    .el-position
      position relative
      .dot
        display inline-block
        width 0.1rem
        height 0.1rem
        border-radius 50%
        margin-right 0.1rem
        position absolute
        top 0
        left -.2rem
        bottom 0
        margin auto
    .el-dropdown-link {
      cursor: pointer;
      color: #409EFF;
    }
    .el-icon-arrow-down {
      font-size: 12px;
    }
    .changeHeight
      padding .2rem
      margin-top .4rem
    .el-collapse
      border-bottom 0
      border-top 0
    .el-collapse >>> .el-collapse-item__header
      color: #4C87FC
      font-weight bold
    .el-collapse >>> .el-collapse-item__arrow
      color: #4C87FC
    .el-collapse >>> .el-collapse-item__content
      padding-bottom 0
    .el_dialogs >>> .el-dialog__body
      padding-left 0
      padding-right 0
    .el_dialogs >>> .el-dialog__header
      padding 0
  
    .block
      height 6rem
      overflow-y auto
      padding-top .2rem
      padding-left .2rem
      box-sizing border-box
  
      .time_right
        width 100%
        margin-top .4rem
        overflow hidden
        word-break break-all
        white-space normal
    .el-timeline-item__node--large
      width .4rem
      height .4rem
    /*滚动条整体样式*/
    ::-webkit-scrollbar{
      width: .1rem;/*竖向滚动条的宽度*/
      height: 10px;/*横向滚动条的高度*/
    }
    ::-webkit-scrollbar-thumb{/*滚动条里面的小方块*/
      background: #cdcdcd;
      border-radius: 5px;
    }
    ::-webkit-scrollbar-track{/*滚动条轨道的样式*/
      background: #f8f8f8;
      border-radius: 5px;
    }
    .el-date-editor
      width: 100% !important

    .fontStyle
      font-size: 16px
  
  </style>
  


// WEBPACK FOOTER //
// src/pages/data_analysis/ProcessAnalysis.vue